<template>
  <div class="nav-bar" style="background-color: white">
    <div v-if="isOrderEmpty" style="text-align: center; padding-top: 1rem">
      ไม่พบรายการคำสั่งซื้อ
    </div>
    <div v-if="searchErrorMessage" style="text-align: center; padding-top: 1rem">
      {{ searchErrorMessage }}
    </div>
    <div v-if="searchErrorMessage || searchResult || searchOrderLoading">
      <div v-for="(item, date) in searchResult" :key="date">
        <div v-for="(orders, status) in orderbyStatus(item)" :key="orders.priority">
          <div v-if="orders.items.length > 0">
            <div v-if="canShowItems(status)">
              <div class="title">
                <p>{{ status }} ({{ orders.items.length }})</p>
                <p>{{ date }}</p>
              </div>
              <CardOrder
                @onclick="ShowDirection"
                v-for="order in orders.items"
                :key="order.id"
                :id="order.id"
                :time="order.time"
                :date="order.date.date"
                :name="order.name"
                :status="order.status"
                :price="order.price"
                :origin="order.origin"
                :destination="order.destination"
                :destinationLocation="order.destinationLocation"
              >
                <div
                  v-if="status === 'FINDDRIVER'"
                  class="column"
                  style="
                    padding: 0px;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                  "
                >
                  <b-button
                    @click.stop="oncancelFindDriver(order)"
                    type="is-danger"
                    style="margin: 5px"
                    class="is-small"
                    outlined
                    icon-right="close"
                  />
                </div>
                <CardProgress
                  v-else
                  :order="order"
                  @onfindLalamove="FindLalamoveDriver"
                  @onfindVilla="FindVillaDriver"
                  @on-edit="onEditOrder"
                />
              </CardOrder>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="orderList">
      <div v-for="(item, date) in orderList" :key="date">
        <div v-for="(orders, status) in orderbyStatus(item)" :key="orders.priority">
          <div v-if="orders.items.length > 0">
            <div v-if="canShowItems(status)">
              <div class="title">
                <p>{{ status }} ({{ orders.items.length }})</p>
                <p>{{ date }}</p>
              </div>
              <CardOrder
                @onclick="ShowDirection"
                v-for="order in orders.items"
                :key="order.id"
                :id="order.id"
                :time="order.time"
                :date="order.date.date"
                :name="order.name"
                :status="order.status"
                :price="order.price"
                :origin="order.origin"
                :destination="order.destination"
                :destinationLocation="order.destinationLocation"
              >
                <div
                  v-if="status === 'FINDDRIVER'"
                  class="column"
                  style="
                    padding: 0px;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                  "
                >
                  <b-button
                    @click.stop="oncancelFindDriver(order)"
                    type="is-danger"
                    style="margin: 5px"
                    class="is-small"
                    outlined
                    icon-right="close"
                  />
                </div>
                <CardProgress
                  v-else
                  :order="order"
                  @onfindLalamove="FindLalamoveDriver"
                  @onfindVilla="FindVillaDriver"
                  @on-edit="onEditOrder"
                />
              </CardOrder>
              <div
                v-if="nextToken[date][status]"
                @click="onLoadmoreData(date, status)"
                class="icon-loadmore"
              >
                <b-icon icon="arrow-down-drop-circle-outline" size="is-medium"> </b-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalEditOrder ref="ModalEditOrder" :orderId="orderId" />
    <b-loading :is-full-page="true" v-model="isLoadingGetQuotation">
      <!-- <b-icon
                pack="fas"
                icon="sync-alt"
                size="is-large"
                custom-class="fa-spin"
            >
            </b-icon>
            <p>กำลังส่ง order ไปที่ lalamove</p> -->
    </b-loading>
  </div>
</template>

<script>
import ServiceTypeLalamove from "@/components/ServiceTypeLalamove";
import LalamoveEditOrder from "@/components/LalamoveEditOrder";
import { statusByRouteName } from "@/settings/orderStatus";
export default {
  name: "ProgressOrder",
  components: {
    CardOrder: () => import("@/components/CardOrder"),
    CardProgress: () => import("@/components/CardProgress"),
    ModalEditOrder: () => import("@/components/ModalEditOrder"),
    // ServiceTypeLalamove: () => import("@/components/ServiceTypeLalamove"),
  },
  data() {
    return {
      isLoading: null,
      orderId: null,
      serviceTypeLalamove: ServiceTypeLalamove,
      lalamoveEditOrder: LalamoveEditOrder,
      isLoadingGetQuotation: false,
    };
  },
  computed: {
    orderList() {
      return this.$store.getters["orders/orders"];
    },
    loadingOrder() {
      return this.$store.getters["orders/loadingOrder"];
    },
    nextToken() {
      return this.$store.getters["orders/nextToken"];
    },
    filter() {
      return this.$store.getters["orders/filter"];
    },
    orderbyStatus() {
      console.log("orderbyStatus");
      return (status) => {
        const sortable = Object.fromEntries(
          Object.entries(status).sort(([, a], [, b]) => a.priority - b.priority)
        );
        return sortable;
      };
    },
    isOrderEmpty() {
      const status = statusByRouteName[this.$route.name];
      return this.$store.getters["orders/isOrderEmpty"](status);
    },
    selectedStatus() {
      return this.$store.getters["orders/selectedStatus"];
    },
    searchResult() {
      return this.$store.getters["orders/searchResult"];
    },
    searchErrorMessage() {
      return this.$store.getters["orders/searchErrorMessage"];
    },
    searchOrderLoading() {
      return this.$store.getters["orders/searchOrderLoading"];
    },
  },
  watch: {
    deliveryOrder() {
      console.log("deliveryOrder", this.deliveryOrder);
      const EventBus = this.$root;
      const position = {
        origin: this.deliveryOrder.origin,
        destination: this.deliveryOrder.destination,
      };
      EventBus.$emit("ShowDirection", position, "delivery");
    },
    loadingOrder() {
      console.log("loadingOrder", this.loadingOrder);
      if (!this.loadingOrder) {
        this.isLoading = this.$buefy.loading.open();
      } else {
        if (this.isLoading) {
          this.isLoading.close();
        }
      }
    },
    searchOrderLoading() {
      console.log("searchOrderLoading", this.searchOrderLoading);
      if (this.searchOrderLoading) {
        this.isLoading = this.$buefy.loading.open();
      } else {
        if (this.isLoading) {
          this.isLoading.close();
        }
      }
    },
  },

  mounted() {
    this.$store.commit("orders/setEmptyOrders");
    this.getOrderTaskWaiting();
  },
  methods: {
    async getOrderTaskWaiting() {
      this.$store.commit("orders/setLoadingOrder", false);
      await Promise.all([
        await this.$store.dispatch("orders/getOrders", { status: "FINDDRIVER" }),
        await this.$store.dispatch("orders/getOrders", { status: "CANCELBYADMIN" }),
        await this.$store.dispatch("orders/getOrders", { status: "CANCELBYDRIVER" }),
        await this.$store.dispatch("orders/getOrders", { status: "PROGRESS" }),
      ]);
      this.$store.commit("orders/setLoadingOrder", true);

    },
    ShowDirection(position) {
      position;
      const EventBus = this.$root;
      EventBus.$emit("ShowDirection", position, "position");
    },
    async onEditOrder(order) {
      this.orderId = order.id;
      this.$refs.ModalEditOrder.modalConfirm = true;
    },
    async oncancelFindDriver(order) {
      console.log(order);
      await this.$store.dispatch("orders/onCancelFindDriverVilla", {
        orderId: order.id,
        nStatus: "CANCELBYADMIN",
        oStatus: order.status,
        driverID: null,
        date: order.date.date,
      });
    },
    async FindVillaDriver(order) {
      const orderDetail = {
        orderId: order.id,
        nStatus: "FINDDRIVER",
        oStatus: order.status,
        driverID: null,
        date: order.date.date,
      };
      try {
        await this.$store.dispatch("orders/onFindDriverVilla", orderDetail);
      } catch (error) {
        console.log(error);
      }
    },
    async onLoadmoreData(date, status) {
      console.log(date);
      if (this.filter) {
        console.log(this.filter, this.nextToken);
        await this.$store.dispatch("orders/getOrdersWithFilter", {
          ...this.filter,
          date: date,
          status: status,
          nextToken: this.nextToken[date][status],
        });
      } else {
        await this.$store.dispatch("orders/getOrders", {
          status: status,
          nextToken: this.nextToken[date][status],
        });
      }
    },
    async FindLalamoveDriver(order) {
      // console.log(order);
      const villaOrder = await this.$store.dispatch("lalamove/orderVillToLalamoveDetail", order);
      // console.log("villa >>>>", villaOrder);
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        props: { villaOrderProp: villaOrder },
        component: this.lalamoveEditOrder,
        events: {
          onConfirm: (order) => {
            // console.log("beforeOrder >>>", order);
            this.$buefy.modal.open({
              parent: this,
              hasModalCard: true,
              component: this.serviceTypeLalamove,
              events: {
                onSelect: async (value) => {
                  console.log("onSelect", value);
                  order.serviceType = value.selectedType;
                  if (value.specialRequest.length) {
                    order.specialRequests = value.specialRequest;
                  }
                  // console.log("lalamovee", order);
                  try {
                    this.isLoadingGetQuotation = true;
                    const res = await this.$store.dispatch("lalamove/getQuotation", order);
                    if (res.statusCode === 201) {
                      this.isLoadingGetQuotation = false;
                      this.$buefy.dialog.confirm({
                        title: "ยืนยันคำสั่งเรียกรถ",
                        message: `<p>ราคา <b>${res.price}</b> บาท</p>
                        <p><b>Type:</b> ${order.serviceType} ${
                          value.specialRequest.length
                            ? "</p><p><b>Request:</b> " + order.specialRequests
                            : ""
                        }</p>
                        <p><b>Origin:</b> ${order.originAddress}</p>
                        <p><b>Destination:</b> ${order.destinationAddress}</p>
                        <p><b>Name:</b> ${order.name}</p>`,
                        cancelText: "ยกเลิก",
                        confirmText: "ยืนยัน",
                        type: "is-success",
                        onConfirm: async () => {
                          // do when it done
                          try {
                            await this.$store.dispatch(
                              "lalamove/placeOrder",
                              res.bodyWithQuotation
                            );
                          } catch (error) {
                            console.log(error);
                            this.$buefy.toast.open({
                              duration: 2000,
                              message: `lalamove is unavailable`,
                              type: "is-warning",
                            });
                          }
                        },
                      });
                    } else {
                      this.isLoadingGetQuotation = false;
                      this.$buefy.dialog.alert({
                        title: "lalamove",
                        message: `<p>คำสั่งซื้อนี้ไม่สามารถเรียกรถได้</p><p>${res.message}</p>`,
                        type: "is-danger",
                        hasIcon: true,
                        icon: "times-circle",
                        iconPack: "fa",
                        ariaRole: "alertdialog",
                        ariaModal: true,
                      });
                    }
                  } catch (error) {
                    console.log(error);
                  }
                },
              },
            });
          },
        },
      });
    },
    canShowItems(status) {
      const allowedStatus = statusByRouteName[this.$route.name] ?? [];
      // console.log("canShowItems", status, allowedStatus);

      // search mode
      // const isSearchOrderMode = this.$store.getters["orders/isSearchOrderMode"];
      // if (isSearchOrderMode) {
      //   status = "ALL";
      // }

      // if (this.selectedStatus !== "ALL") {
      //   return status === this.selectedStatus;
      // }

      return allowedStatus.includes(status);
    },
  },
};
</script>
<style scoped>
.title {
  z-index: 10;
  font-size: 15px;
  padding: 10px;
  margin: 0;
  position: sticky;
  top: 0px;
  background-color: white;
  display: flex;
  justify-content: space-between;
}
.icon-loadmore {
  padding: 5px;
  text-align: center;
  cursor: pointer;
}
</style>
